import { socket } from "../index";

const emitCreateRoom = (
  name: string,
  description: string,
  maxParticipants: number,
  isProject: boolean,
  isSecret: boolean,
  password: string | null = null,
) => {
  socket?.emit('CREATE_ROOM', { 
    name,
    description,
    maxParticipants,
    isProject,
    isSecret,
    password,
  });
}

export default emitCreateRoom;